import { IAppDefinition, IAppManifest } from '../Services/hosted-web-content-sdk.interface';
import { Test, Yammer, Monday, TeamsTestTab, ToDo } from './app-definitions';

export const AppDefEnum = {
  Test: 'Test',
  TeamsTestTab: 'TeamsTestTab',
  Yammer: 'Yammer',
  Monday: 'Monday',
  ToDo: 'ToDo',
};

export const getAppManifest = (app: string): IAppManifest => {
  switch (app) {
    case AppDefEnum.Yammer:
      return Yammer;
    case AppDefEnum.Monday:
      return Monday;
    case AppDefEnum.Test:
      return Test;
    case AppDefEnum.TeamsTestTab:
      return TeamsTestTab;
    case AppDefEnum.ToDo:
      return ToDo;
    default:
      return Test;
  }
};

export const getAppDefinition = (app: string): IAppDefinition => getAppManifest(app);
